
<div class="flex flex-row w-full">
  <div class="flex-grow max-w-[80%]">
    {{ text.name }}<br />

    <div class="flex space-x-1 pt-2 px-1">
      <button type="button" @click="toggleBold">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
          stroke="currentColor" class="text-gray-600 cursor-pointer w-4 h-4 hover:text-brandhelfer-blue">
          <path stroke-linejoin="round"
            d="M6.75 3.744h-.753v8.25h7.125a4.125 4.125 0 0 0 0-8.25H6.75Zm0 0v.38m0 16.122h6.747a4.5 4.5 0 0 0 0-9.001h-7.5v9h.753Zm0 0v-.37m0-15.751h6a3.75 3.75 0 1 1 0 7.5h-6m0-7.5v7.5m0 0v8.25m0-8.25h6.375a4.125 4.125 0 0 1 0 8.25H6.75m.747-15.38h4.875a3.375 3.375 0 0 1 0 6.75H7.497v-6.75Zm0 7.5h5.25a3.75 3.75 0 0 1 0 7.5h-5.25v-7.5Z" />
        </svg>
      </button>
    </div>

    <editor-content v-if="editor" :editor="editor" @paste="handlePaste"
      class="editor w-full h-full text-inherit resize-none overflow-auto py-2 px-3 bg-white block sm:text-sm"
      :class="[smallscreen ? 'text-xs' : '']" />




    <div v-if="hasTextColors" class="mt-2">
      <div v-for="(color, idx) in textColors" :key="idx" :style="`background-color: rgba(${color},1)`"
        @click="changeTextColor(color)"
        class="w-2 h-2 rounded float-left border-2 hover:border-brandhelfer-green cursor-pointer" :class="[
          smallscreen ? 'p-3 mr-1 mb-1' : 'p-4 mr-2 mb-2',
          selectedColor == color ? 'border-brandhelfer-green cursor-default' : 'border-gray-200'
        ]">
      </div>
    </div>
  </div>
  <div class="w-1/5">
    <toggle :idx="text.id" :enabled="text.enabled" @toggled="statusToggled"></toggle>
  </div>

  <horizontal-divider />
</div>
